import { render, staticRenderFns } from "./Legacy.vue?vue&type=template&id=6cf6a104&scoped=true&"
import script from "./Legacy.vue?vue&type=script&lang=js&"
export * from "./Legacy.vue?vue&type=script&lang=js&"
import style0 from "./Legacy.vue?vue&type=style&index=0&id=6cf6a104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6a104",
  null
  
)

export default component.exports